function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1062.663 663.48H364.649l-129.892-99.373 174.454-72.994.484 5.856 215.041 81.41 14.43 39.566 3.926-16.87 13.643 16.87h17.548l4.817-10.321h12.041l.688-21.33h-15.138l-7.915-12.733 7.225 4.817h20.646v-23.053h-18.923l-8.948-18.921 10.324 10.321h20.643v-14.109h27.829v14.11h20.643l10.32-10.322-8.946 18.921h-18.924v23.053h20.646l7.224-4.817-7.911 12.732h-15.141l.688 21.33h12.044l4.814 10.322h17.55l13.644-16.87 3.924 16.87 14.43-39.567 215.042-81.409.484-5.854 174.45 72.992-129.89 99.373",
  fill: "#d5d8d7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M649.165 34.064L594.46 6.196 381.825 300.372 125.84 412.882l17.547 37.157 273.534-21.674-10.322-34.062 18.58 26.838 72.253-32 171.344-218.826-19.61-136.251m128.981 0l54.709-27.868 212.632 294.176 255.984 112.51-17.55 37.157-273.53-21.674 10.323-34.062-18.58 26.838-72.254-32-171.346-218.826 19.612-136.251",
  fill: "#dc6c24"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M179.995 447.14h-.002l.007-.001 224.1-17.758-224.105 17.759",
  fill: "#d6a481"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M180 447.139l204.924-44.171-3.427-59.62 49.342-58.935 48.656 19.872L621.652 87.291l-9.87 51.818-102.626 196.755h-.001l-.684 1.313-77.1-26.482-34.062 36.641 6.791 82.045L180 447.14",
  fill: "#ba4620"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1247.321 447.14h-.002l-224.106-17.759 224.104 17.758.004.001",
  fill: "#d6a481"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1247.317 447.139l-224.104-17.758 6.791-82.045-34.063-36.641-77.098 26.482-.683-1.309v-.004h-.003L815.532 139.109l-9.872-51.821 142.159 216.997 48.657-19.872 49.34 58.935-3.427 59.62 204.932 44.172",
  fill: "#ba4620"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M611.781 139.11l-128.8 246.935L613.04 532.616l16.516-367.807-17.774-25.7",
  fill: "#dc6c24"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M125.84 412.881l49.601 31.946-9.574 45.222-18.351 52.514H125.84l6.084-42.906-6.084-19.213-27.869 26.027-8.143 41.257 2.39 36.466-16.955 2.1L61.5 547.411l6.193-48.513-29.91 90.414H20.686l2.624-39.838-8.58 39.838H0l5.764-50.594 35.863-75.564 84.213-50.274m1175.632.001l-49.601 31.946 9.576 45.222 18.349 52.514h21.676l-6.085-42.906 6.085-19.213 27.87 26.027 8.138 41.257-2.387 36.466 16.96 2.1 13.76-38.882-6.2-48.513 29.92 90.414h17.094L1404 549.475l8.587 39.838h14.72l-5.76-50.594-35.867-75.564-84.208-50.274",
  fill: "#67757a"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M815.532 139.11l128.8 246.935-130.057 146.571-16.516-367.807 17.773-25.7",
  fill: "#dc6c24"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M809.116 191.648l-95.459-21.333-95.458 21.333L502.593 378.82 613.04 532.616h201.236L924.723 378.82 809.116 191.648",
  fill: "#b04d1f"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M918.16 335.868l-.003-.004h.003v.004",
  fill: "#9c2f1f"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M524.84 342.801l-15.604-5.36-.081-1.577h.001l18.168 2.916-2.484 4.021m377.635-.001l-2.483-4.021 18.165-2.915.003.004-.081 1.572-15.604 5.36",
  fill: "#ba4620"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M727.572 532.616h-27.83v-13.419h-19.954l-13.764-25.114 21.677-10.668-6.193-33.376-33.03 11.701-9.74 18.065v-.001l-14.002 25.975-58.147-148.636L524.84 342.8l2.484-4.021 54.075 8.679 43.337 123.353 17.857-26.273 50.388-12.791 9.859 55.51-23.927 8.909 4.302 12.337 30.442-2.059 30.44 2.059 4.303-12.337-23.925-8.908 9.857-55.511 50.388 12.79 17.857 26.274 43.339-123.353 54.076-8.68 2.483 4.021-41.752 14.343-58.146 148.636-14-25.975-.002.003-9.74-18.067-33.028-11.701-6.196 33.376 21.677 10.668-13.763 25.114h-19.953v13.419",
  fill: "#93331d"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M595.325 228.68l15.608-35.099-5.29 18.395-10.318 16.704m261.842 40.765l-35.499-57.474-5.288-18.388 8.733-4.171-9.581-50.301v-.002l28.412 54.472-14.953 7.708 28.176 68.156",
  fill: "#ba4620"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M713.657 375.556L558.86 310.695l36.466-82.015 10.318-16.704-24.244 84.315 132.258 51.168 132.259-51.168-24.248-84.32 35.499 57.474 17.053 41.25-160.563 64.861",
  fill: "#93331d"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M802.577 505.779l-23.742-44.039-33.028-11.701-6.196 33.376 21.677 10.668-13.763 25.114h-19.953v27.528h20.643l10.32-10.321-8.946 18.921h-18.924v23.053h20.646l7.224-4.817-7.911 12.732h-15.141l.688 21.33h12.044l4.814 10.322h17.55l31.998-39.567v-72.6m13.247-314.13l-102.167 29.717-102.169-29.717-30.09 104.643 132.26 51.168 132.258-51.168-30.092-104.643",
  fill: "#67757a"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M179.995 447.14L65.58 487.944l-50.712-6.168 14.39-23.984 96.582-44.91 54.155 34.258m1067.326 0l114.412 40.804 50.707-6.168-14.387-23.984-96.581-44.91-54.15 34.258m-444.745 58.639v72.6l215.042-81.41 12.385-149.633-34.063-36.641-135.218 46.448-58.146 148.636m0 0l-14-25.975-23.502 38.979 23.072 99.162 14.43-39.567v-72.6",
  fill: "#dc6c24"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M798.275 48.516L756.472.003H670.84l-41.803 48.513L602.2 189.412l37.817 18.063L713.657 67.6l73.639 139.874 37.817-18.063-26.838-140.896",
  fill: "#cf591e"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M786.92 54.192l-73.263-36.643-73.265 36.643-8.257 114.067s6.536 2.509 81.522 33.03c74.984-30.521 81.522-33.03 81.522-33.03L786.92 54.192",
  fill: "#839b9d"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M754.17 84.643l-40.513 16.508-40.517-16.508-20.535 55.05 23.054 15.482 37.998-11.354 37.998 11.354 23.054-15.482-20.538-55.05",
  fill: "#67757a"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M692.981 100.572l-9.765 9.765-9.767-9.765 9.767-3.379 9.765 3.379m41.351 0l9.765 9.765 9.766-9.765-9.766-3.379-9.765 3.379",
  fill: "#4a555a"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M770.923 151.736l-57.266-16.859-57.266 16.859-24.256 82.576 40.845 45.761h81.352l40.847-45.761-24.256-82.576",
  fill: "#dc6c24"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M762.665 158.961l-49.008 77.674-49.009-77.674-15.483 65.286 32.515 38.966h63.955l32.512-38.966-15.482-65.286",
  fill: "#e3ce8b"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M762.665 158.961l-49.008-24.084-49.009 24.084-8.257 60.899 57.266 28.559 57.266-28.559-8.258-60.899",
  fill: "#839b9d"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M687.356 159.305h10.323l5.161 11.01-12.387-4.128-3.097-6.882m52.599 0h-10.32l-5.162 11.01 12.388-4.128 3.094-6.882",
  fill: "#67757a"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M654.756 221.708l18.693-14.233-8.801-48.514zm117.803 0l-18.694-14.233 8.8-48.514 9.894 62.747",
  fill: "#e3ce8b"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M656.39 219.86h57.267v7.445l-57.266-7.445m114.532 0h-57.266v7.445l57.266-7.445M624.736 505.779l23.741-44.039 33.031-11.701 6.193 33.376-21.677 10.668 13.764 25.114h19.955v27.528H679.1l-10.324-10.321 8.948 18.921h18.923v23.053H676l-7.225-4.817 7.915 12.732h15.138l-.688 21.33H679.1l-4.817 10.322h-17.548l-31.999-39.567v-72.6",
  fill: "#67757a"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M638.737 479.804l-14.001 25.975-58.147-148.636-135.218-46.448-34.062 36.641 12.386 149.633 215.041 81.41 14.43 39.566 23.073-99.162-23.502-38.979",
  fill: "#dc6c24"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M409.21 491.113l-3.855-46.574v.001l3.856 46.573",
  fill: "#d6a481"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M639.167 617.945l-14.431-39.567-215.041-81.409-.484-5.856.484 5.856 215.041 81.41 14.43 39.566",
  fill: "#b0896d"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M639.167 617.945l-14.431-39.567-215.041-81.409-.484-5.856-3.856-46.573 13.834 39.979 205.547 64.358 22.02 36.45-7.59 32.618m163.411-39.567v-29.5l205.547-64.36 13.833-39.98-4.338 52.431-215.042 81.41",
  fill: "#ba4620"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M788.147 617.945l-7.588-32.618 22.018-36.45v29.501l-14.43 39.567",
  fill: "#ba4620"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M787.296 207.475l-9.47-32.243c15.271-6.175 17.353-6.973 17.353-6.973L786.92 54.192l-73.263-36.643V.003h42.815l41.803 48.513 26.838 140.896-37.817 18.063",
  fill: "#ad3920"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M777.825 175.232l-6.902-23.496-9.835-2.896 13.621-9.147-20.538-55.05-40.514 16.508V17.549l73.263 36.643 8.259 114.067s-2.082.798-17.354 6.973",
  fill: "#6b6251"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M761.088 148.84l-47.43-13.963v-33.726l40.513-16.508 20.538 55.05-13.621 9.147m-16.99-51.647l-9.766 3.379 9.765 9.765 9.766-9.765-9.766-3.379",
  fill: "#56493e"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M744.097 110.337l-9.765-9.765 9.765-3.379 9.766 3.379-9.766 9.765",
  fill: "#3e362e"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M754.332 280.073h-40.675v-16.86h31.978l32.512-38.966-15.482-65.286-49.008-24.084 47.431 13.963 9.835 2.896 6.902 23.496 9.471 32.243 7.883 26.837-40.847 45.761",
  fill: "#ba4620"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M745.635 263.213h-31.978V248.42l56.787-28.32 2.115 1.609-9.894-62.747 15.482 65.286-32.512 38.966",
  fill: "#bf8248"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M713.657 248.419v-21.114l56.59-7.357.197.15-56.787 28.32m56.475-28.558h-56.475v-84.983l49.008 24.084-8.8 48.514 16.267 12.385m-40.497-60.555l-5.162 11.01 12.388-4.128 3.094-6.882h-10.32",
  fill: "#6b6251"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M724.473 170.315l5.162-11.01h10.32l-3.094 6.882-12.388 4.128",
  fill: "#56493e"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M772.559 221.708l-2.115-1.61-.197-.15.676-.088h-.791l-16.267-12.385 8.8-48.514 9.894 62.747",
  fill: "#bf8248"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M713.657 227.305v-7.445h57.266l-.676.088-56.59 7.357",
  fill: "#56493e"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M602.2 22.175l41.63 9.173-49.37-25.152-212.635 294.176-255.985 112.51 267.081-102.187L602.2 22.175m-43.341 340.36l64.044 138.556-56.314-143.95-135.218-46.446-34.062 36.641 34.707-25.496 126.843 40.695m437.082-51.84L860.723 357.14 804.41 501.093l66.634-137.186 122.418-41.116 36.541 24.545-34.063-36.641",
  fill: "#f79553"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M590.97 289.395l19.962-95.812-29.533 102.708 132.258 51.168 132.259-51.168-131.39 43.326-123.557-50.222",
  fill: "#99a3a4"
});

function SvgOrangUtan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1427.307,
    height: 663.48,
    viewBox: "0 0 1427 663"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44);
}

export default SvgOrangUtan;